import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { I18nProvider } from "@/i18n";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AppLayout from "@/pages/AppLayout";
import Dashboard from "@/pages/Dashboard";
import Chat from "@/pages/Chat";
import VideoProducer from "@/pages/VideoProducer";
import ImageProducer from "@/pages/ImageProducer";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import Integrations from "@/pages/Integrations";
import Help from "@/pages/Help";
import Admin from "@/pages/Admin";
import AiWorkforce from "@/pages/AiWorkforce";
import Pricing from "@/pages/Pricing";
import BillingSuccess from "@/pages/BillingSuccess";
import Referrals from "@/pages/Referrals";
import Interview from "@/pages/Interview";
import InterviewBank from "@/pages/InterviewBank";
import InterviewSession from "@/pages/InterviewSession";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Support from "@/pages/Support";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/support" element={<Support />} />
      <Route path="/auth" element={<Auth />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/app" element={<AppLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="chat" element={<Chat />} />
        <Route path="video-producer" element={<VideoProducer />} />
        <Route path="image-producer" element={<ImageProducer />} />
        <Route path="projects" element={<Projects />} />
        <Route path="projects/:id" element={<ProjectDetail />} />
        <Route path="integrations" element={<Integrations />} />
        <Route path="help" element={<Help />} />
        <Route path="admin" element={<Admin />} />
        <Route path="admin/ai-workforce" element={<AiWorkforce />} />
        <Route path="billing" element={<Pricing />} />
        <Route path="referrals" element={<Referrals />} />
        <Route path="billing/success" element={<BillingSuccess />} />
        <Route path="interview" element={<Interview />} />
        <Route path="interview/:id" element={<InterviewBank />} />
        <Route path="interview/session/:id" element={<InterviewSession />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  return (
    <div className="App">
      <GoogleOAuthProvider clientId={googleClientId}>
        <I18nProvider>
          <ThemeProvider>
            <AuthProvider>
              <BrowserRouter>
                <Toaster position="top-right" richColors />
                <AppRouter />
              </BrowserRouter>
            </AuthProvider>
          </ThemeProvider>
        </I18nProvider>
      </GoogleOAuthProvider>
    </div>
  );
}

export default App;
